import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import {
  Alert,
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import AppContext from "../../context/Context";
import APICall from "../../services/apiCall";
import Loader from "../common/Loader";
import SikkaInput from "../common/SikkaInput";

const TeamMemberStatusUpdateModal = ({
  partnerDetailsData,
  setOpenStatusUpdateModal,
  updateTeamMemberStatusValue,
  setIsRefresh,
  userListActive,
  //   setFetchPartnerDetails,
  //   setFetchApplicationDetails,
}) => {
  const [loading, setLoading] = useState(false);
  const { loginUserDetails } = useContext(AppContext);
  const [defaultSeats, setDefaultSeats] = useState(0); // Default seats from API
  const [monthlyCost, setMonthlyCost] = useState(0); // Monthly cost from API
  const { register, handleSubmit, errors, setValue } = useForm();

  useEffect(() => {
    // get recovery questions
    let params = {
      devid:
        loginUserDetails.is_partner == "1"
          ? partnerDetailsData.parent_devid
          : loginUserDetails.parent_dev_id,
    };
    APICall.servertrip(
      "GET",
      "get_team_member_config",
      loginUserDetails,
      params
    )
      .then((res) => {
        if (res.data.items.length > 0) {
          setDefaultSeats(res.data.items[0].defaultSeats);
          setMonthlyCost(res.data.items[0].chargePerExtraSeat);
        } else {
          setDefaultSeats(5);
          setMonthlyCost(100);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  const handlePartnerStatusChange = (values) => {
    setIsRefresh(false);
    setLoading(true);

    let body = {
      user_name: partnerDetailsData.username,
      status: updateTeamMemberStatusValue, //partner email address
      // status: partnerDetailsData.dev_status === "active" ? "inactive" : "active", // value shold be active/inactive
      dev_id: partnerDetailsData.devid,
      partner_name: partnerDetailsData.partner_name,
      developer_name: partnerDetailsData.dev_name,
      //   notify_partner: values.notifyPartner, // value should be yes/no
      add_updated_by: loginUserDetails.user_name, //loggedin user's username
      is_add_updated_by_admin:
        loginUserDetails.is_partner === "0" ? "true" : "false",
      before_updated_value: {
        status: partnerDetailsData.dev_status,
      },
    };

    APICall.servertrip(
      "PUT",
      "partner_status",
      loginUserDetails,
      undefined,
      body
    ).then(
      (res) => {
        toast.success("TeamMember status successfully updated");
        setOpenStatusUpdateModal(false);
        setLoading(false);
        setIsRefresh(true);
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        toast.error(resMessage);
        setOpenStatusUpdateModal(false);
        setLoading(false);
      }
    );
  };

  return (
    <>
      <Form onSubmit={handleSubmit(handlePartnerStatusChange)}>
        <Row>
          <Col>
            <Row>
              <Col>
                <SikkaInput
                  label="Updated By"
                  value={loginUserDetails.user_name}
                  name="updatedBy"
                  id="updatedBy"
                  disabled
                  innerRef={register({
                    required: "User Name is required",
                  })}
                  errors={errors}
                />
              </Col>
            </Row>
            <SikkaInput
              label="Comment"
              name="comment"
              type="textarea"
              id="SetSuperAdminComment"
              innerRef={register({
                required: "Comment is required",
              })}
              errors={errors}
            />
          </Col>
          {updateTeamMemberStatusValue === "active" && (
            <>
              {userListActive.length >= 5 && (
                <div className="p-3">
                  <Alert color="primary">
                    Adding additional seats beyond {defaultSeats} will incur an
                    extra ${monthlyCost} per user per month.
                  </Alert>
                </div>
              )}
            </>
          )}
        </Row>
        <Row
          className="modal-footer px-md-3 bg-light"
          style={{
            marginLeft: "-16px",
            marginRight: "-16px",
            marginBottom: "-16px",
          }}
        >
          <Button
            color="outline-primary"
            size="sm"
            className="ml-auto"
            type="submit"
            disabled={loading}
          >
            Submit
          </Button>
          <Button
            size="sm"
            color="outline-secondary"
            onClick={() => {
              setOpenStatusUpdateModal(false);
            }}
          >
            Cancel
          </Button>
        </Row>
      </Form>
    </>
  );
};

export default TeamMemberStatusUpdateModal;
